// extracted by mini-css-extract-plugin
var _1 = "CelsiusClaimPageStyles-module__action-button___qE_wF";
var _2 = "CelsiusClaimPageStyles-module__action-button___qE_wF";
var _3 = "CelsiusClaimPageStyles-module__checkbox___i7cYj";
var _4 = "CelsiusClaimPageStyles-module__header___IT0M1";
var _5 = "CelsiusClaimPageStyles-module__header-text___Paror";
var _6 = "CelsiusClaimPageStyles-module__header-title___YzMwq";
var _7 = "CelsiusClaimPageStyles-module__header-wrapper-padding___roNwe";
var _8 = "CelsiusClaimPageStyles-module__header-text___Paror";
var _9 = "CelsiusClaimPageStyles-module__header-title___YzMwq";
var _a = "CelsiusClaimPageStyles-module__header-wrapper-padding___roNwe";
var _b = "CelsiusClaimPageStyles-module__link-btn___Hf8Kn";
var _c = "CelsiusClaimPageStyles-module__link-btn___Hf8Kn";
var _d = "CelsiusClaimPageStyles-module__loader-wrapper___PZdLG";
var _e = "CelsiusClaimPageStyles-module__loader-wrapper___PZdLG";
var _f = "CelsiusClaimPageStyles-module__margin-bottom-0___CF2OC";
var _10 = "CelsiusClaimPageStyles-module__margin-bottom-0___CF2OC";
var _11 = "CelsiusClaimPageStyles-module__padding-bottom-20___PhvPe";
var _12 = "CelsiusClaimPageStyles-module__padding-bottom-20___PhvPe";
var _13 = "CelsiusClaimPageStyles-module__page-wrapper___o5Pi3";
var _14 = "CelsiusClaimPageStyles-module__page-wrapper___o5Pi3";
var _15 = "CelsiusClaimPageStyles-module__read-more___Ll8Fp";
var _16 = "CelsiusClaimPageStyles-module__read-more___Ll8Fp";
export { _1 as "action-button", _2 as "actionButton", _3 as "checkbox", _4 as "header", _5 as "header-text", _6 as "header-title", _7 as "header-wrapper-padding", _8 as "headerText", _9 as "headerTitle", _a as "headerWrapperPadding", _b as "link-btn", _c as "linkBtn", _d as "loader-wrapper", _e as "loaderWrapper", _f as "margin-bottom-0", _10 as "marginBottom0", _11 as "padding-bottom-20", _12 as "paddingBottom20", _13 as "page-wrapper", _14 as "pageWrapper", _15 as "read-more", _16 as "readMore" }
